//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelBillLogs', {
//        templateUrl: 'views/components/views/travelBillLogs/travelBillLogs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'travelBillLogsService', function ($stateParams, travelBillLogsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let travelBillNo = $stateParams.travelbill_no;
            
//            vm.model = {
//                itemsListLogs: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALL

//            async function loadLogs() {
//                vm.model.itemsListLogs = await travelBillLogsService.listLogs({ travelbill_no: travelBillNo });
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadLogs();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
